
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fechar menu mobile ao mudar de rota
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: 'Funcionalidades', path: '/funcionalidades' },
    { name: 'Planos', path: '/planos' },
    { name: 'Blog', path: '/blog' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contato', path: '/#contato' },
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    if (path === '/#contato') {
      e.preventDefault();
      if (location.pathname === '/') {
        const section = document.getElementById('contato');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        window.REACT_APP_NAVIGATE('/');
        setTimeout(() => {
          const section = document.getElementById('contato');
          if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
          }
        }, 500);
      }
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-white shadow-soft'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/d59a2823757fedf9fab30970c772cc93/fc97616593fadb8f9287babe64f21a28.png" 
              alt="TG WEB - Sistema de Gestão para Transportadoras" 
              className="h-8 sm:h-10 lg:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path === '/#contato' ? '#' : link.path}
                onClick={(e) => handleNavClick(e, link.path)}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled || !isHome
                    ? 'text-neutral-700 hover:text-primary'
                    : 'text-white hover:text-secondary'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://topgerenteweb.com.br/sistema/"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-4 xl:px-5 py-2 text-sm font-semibold rounded-lg border transition-all whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? 'border-primary text-primary hover:bg-primary hover:text-white'
                  : 'border-white text-white hover:bg-white/10'
              }`}
            >
              Entrar
            </a>
            <a
              href="https://wa.me/5511999999999?text=Olá,%20gostaria%20de%20agendar%20uma%20demonstração%20do%20TG%20WEB"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 xl:px-6 py-2.5 bg-secondary text-white text-sm font-semibold rounded-lg hover:bg-secondary-600 transition-all shadow-soft hover:shadow-hover whitespace-nowrap cursor-pointer"
            >
              Agende uma Demonstração
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors cursor-pointer ${
              isScrolled || !isHome
                ? 'text-neutral-700 hover:bg-neutral-100'
                : 'text-white hover:bg-white/10'
            }`}
            aria-label="Menu"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div 
        className={`lg:hidden bg-white border-t border-neutral-200 transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 py-4 space-y-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path === '/#contato' ? '#' : link.path}
              onClick={(e) => {
                handleNavClick(e, link.path);
                if (link.path !== '/#contato') setIsMobileMenuOpen(false);
              }}
              className="block px-4 py-3 text-neutral-700 hover:bg-neutral-50 rounded-lg transition-colors font-medium"
            >
              {link.name}
            </Link>
          ))}
          <div className="pt-2 space-y-2">
            <a
              href="https://topgerenteweb.com.br/sistema/"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-3 border border-primary text-primary text-center font-semibold rounded-lg hover:bg-primary hover:text-white transition-colors cursor-pointer"
            >
              Entrar
            </a>
            <a
              href="https://wa.me/5511999999999?text=Olá,%20gostaria%20de%20agendar%20uma%20demonstração%20do%20TG%20WEB"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-3 bg-secondary text-white text-center font-semibold rounded-lg hover:bg-secondary-600 transition-colors cursor-pointer"
            >
              Agende uma Demonstração
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
